import { Descriptor } from '../../Descriptor'
import { formatDateOptions } from '../../Format'
import { Options } from '../../Options'
import { ChartAxisConstants } from './ChartAxis.constants'

export const chartAxisOptions = {
  ...Options.asRecord(
    Options.createOption({
      key: 'showTicks',
      inputKind: 'boolean',
      defaultValue: ChartAxisConstants.defaultShowXAxisTicks,
      label: 'Show ticks',
      description: 'Draw tick marks on the axis baseline.',
      category: 'Axis',
    }),
    Options.createOption({
      key: 'showLine',
      inputKind: 'boolean',
      defaultValue: ChartAxisConstants.defaultShowXAxisLine,
      label: 'Show axis line',
      description: 'Draw the axis baseline.',
      category: 'Axis',
    }),
    Descriptor.options.label,
    Options.createOption({
      key: 'ticks',
      inputKind: 'number_array',
      ofType: Options.list(Options.scalar<number>('Float')),
      label: 'Tick values',
      description: 'Override auto-generated tick values.',
      category: 'Axis',
    }),
    Options.createOption({
      key: 'axisTickLabelLayout',
      inputKind: 'select',
      defaultValue: ChartAxisConstants.defaultAxisTickLabelLayout,
      selectChoices: [
        { value: 'diagonal', label: 'Diagonal' },
        { value: 'horizontal', label: 'Horizontal' },
        { value: 'vertical', label: 'Vertical' },
        { value: 'diagonal-stacked', label: 'Diagonal stacked' },
        { value: 'horizontal-stacked', label: 'Horizontal stacked' },
        { value: 'vertical-stacked', label: 'Vertical stacked' },
      ],
      label: 'Tick label layout',
      description:
        'Orientation of tick labels. Stacked variants can wrap content.',
      category: 'Axis',
    }),
    Options.createOption({
      key: 'axisTickLabelTruncation',
      inputKind: 'number',
      defaultValue: ChartAxisConstants.defaultAxisTickLabelTruncation,
      min: 3,
      step: 1,
      label: 'Tick label truncation',
      description:
        'Maximum tick-label characters before truncating with an ellipsis.',
      category: 'Axis',
    }),
    Options.createNested({
      key: '_xAxis',
      label: 'X axis',
      description: 'Category-axis display and scale options.',
      category: 'Axis',
    }),
    Options.createNested({
      key: '_yAxis',
      label: 'Y axis',
      description: 'Measure-axis display and scale options.',
      category: 'Axis',
    }),
  ),
  ...formatDateOptions,
}

export type AxisTickLabelLayout =
  | 'diagonal'
  | 'horizontal'
  | 'vertical'
  | 'diagonal-stacked'
  | 'horizontal-stacked'
  | 'vertical-stacked'

export type AxisTickLabelOrientation = 'horizontal' | 'diagonal' | 'vertical'

export type ChartAxisOptions = Options.TypeOf<typeof chartAxisOptions>
export type ChartAxisResolvedOptions = Options.ResolvedTypeOf<
  typeof chartAxisOptions
>
